import React, { useState, useEffect, useRef, useMemo } from 'react';
import { FileProps } from '../Files/documents/types';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from '../../store';
import {  fetchDocumentContent } from '../../store/actions/DocumentsAction';
import { Tooltip } from '@mui/material';
interface DocumentViewerProps {
  file: FileProps;
  onClose: () => void;
  onUpdateFile: (file: FileProps) => void;
}

const DocumentViewer: React.FC<DocumentViewerProps> = ({ file, onClose, onUpdateFile }) => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const [content, setContent] = useState<string>(file.content || '');
    const quillRef = useRef<ReactQuill | null>(null);
      const modules = useMemo(() => ({
        toolbar: {
          container: '#custom-toolbar',
        },
      }), []);

      useEffect(() => {
        const fetchContent = async () => {
          try {
            const content: string = await dispatch(fetchDocumentContent(file.FileID));
            setContent(content);
          } catch (error) {
            console.error('Error fetching document content:', error);
          }
        };
        fetchContent();
      }, [file.FileID, dispatch]);
      



    useEffect(() => {
      setContent(file.content || '');
    }, [file.content]);
  
      
    return (
      <div className="w-1/2 bg-white dark:bg-gray-800 border-l border-gray-200 dark:border-gray-700 flex flex-col h-full">
        <div className="flex flex-row items-center justify-between px-4  border-gray-200 dark:border-gray-700">
        </div>
      <div className="flex-1 px-4 h-[100%] min-h-[100%] max-h-[100%]">
      <div id="custom-toolbar" className="flex items-center w-full rounded text-xs">
          <select className="ql-font"></select>
          <select className="ql-size"></select>
          <button className="ql-bold"></button>
          <button className="ql-italic"></button>
          <button className="ql-underline"></button>
          <button className="ql-align" value=""></button>
          <button className="ql-align" value="center"></button>
          <button className="ql-align" value="right"></button>
          <button className="ql-align" value="justify"></button>
          <button className="ql-list" value="ordered"></button>
          <button className="ql-list" value="bullet"></button>
          <div className="flex-1"></div>

          <Tooltip title={t('Close')}>
            <button
              onClick={onClose}
              className="ml-2 text-gray-600 hover:text-gray-900 dark:text-gray-300 dark:hover:text-white mb-2"
              style={{ background: 'transparent', border: 'none' }}
            >
              <i className="fas fa-times-circle text-lg"></i>
            </button>
          </Tooltip>
      </div>
          <ReactQuill 
            ref={quillRef}
            value={content} 
            onChange={setContent} 
            className="sm:h-[75%] sm:max-h-[75%] sm:min-h-[75%] lg:h-[90%] lg:max-h-[90%] lg:min-h-[90%] md:h-[90%] md:max-h-[90%] md:min-h-[90%] 2xl:h-[95%] 2xl:max-h-[95%] 2xl:min-h-[95%] rounded-md"
            theme="snow"
            style={{ scrollbarWidth: 'thin' }} 
            modules={modules}
          />
      </div>
    </div>
  );
};

export default DocumentViewer;
